import { render, staticRenderFns } from "./ForgetVerificationOTPsms.vue?vue&type=template&id=c764be34&lang=html"
import script from "./ForgetVerificationOTPsms.vue?vue&type=script&lang=js"
export * from "./ForgetVerificationOTPsms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports